export default "__VITE_ASSET__BRU5QFpv__"